// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { i18n } from './lang'
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp) // $jsonp被挂载到vue原型上,可直接使用vm.$jsonp()
// 引入element UI
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 公共样式
import './assets/css/xunyou.css'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
//视频
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer);

import myloading from "./components/myloading";
Vue.component("myloading", myloading);

//引入vue-lazyload
import errorimg from "@/assets/images/summary_bg.jpg";
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  error: errorimg,//图片错误的替换图片路径(可以使用变量存储)
  loading: errorimg,//正在加载的图片路径(可以使用变量存储)
})

import axios from 'axios';
Vue.prototype.setGlobleTitle = (title) => { document.title = title }
Vue.prototype.$axios = axios;

//线上
Vue.prototype.$payUrl = 'https://b2b.naturehike.cn/camp/bingoPay'
Vue.prototype.$PCUrl = 'https://b2b.naturehike.cn'
Vue.prototype.$baseUrl = 'https://b2b.naturehike.cn/camp'

// 测试环境
// Vue.prototype.$payUrl = 'http://171.168.1.207:8080/camp/bingoPay'
// Vue.prototype.$PCUrl = 'http://171.168.1.207:8080'
// Vue.prototype.$baseUrl = 'http://171.168.1.207:8080/camp'


// Vue.prototype.$payUrl = 'http://localhost:8080/camp/bingoPay'
// Vue.prototype.$PCUrl = 'http://localhost:8080'
// Vue.prototype.$baseUrl = 'http://localhost:8080/camp'



import myfun from "./utils/myfun.js";
Vue.prototype.$myfun = myfun;
Vue.prototype.$tipid = null;

Vue.config.productionTip = false;

// 屏蔽错误信息
// Vue.config.errorHandler = (err) => {
//     return false
//   };
// 屏蔽警告信息
// Vue.config.warnHandler = (message) => {
//   return false
// };


// 使用element UI
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value), //这里会根据选的语言切换Element-ui的语言
});
//地图定位组件

const myInstall = (args) => {
  // console.log('my install ', args);
  // console.log('my install all', arguments);
}
Vue.use(myInstall)

// 过滤器
import * as custom from './utils/util'
import Axios from 'axios';
// import { arguments } from 'file-loader';

// 引入layui
// import layui from './assets/layui/layui'
// // import './assets/layui/css/modules/layer/default'
// Vue.prototype.$layui = layui

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

function buryingoint() {
  //埋点
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?c64002375663300fd0641c9c67f73466";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

// 路由拦截器
router.beforeEach((to, from, next) => {
  let appUrl = Vue.prototype.$baseUrl;
  if (appUrl.includes('naturehike')) {
    //正式环境埋点
    buryingoint();
  }
  let userObj = JSON.parse(localStorage.getItem("userdata")) || {};
  if (!userObj.accountingCompanyCode) {
    let strObj = {
      accountingCompanyCode: 102,
      brand: "宁波市云汭旅游用品有限公司"
    };
    localStorage.setItem("userdata", JSON.stringify(strObj));
  }
  if (to.matched.length != 0) {
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
      localStorage.setItem("backFullPath", to.fullPath);
      if (Boolean(localStorage.getItem("userdata"))) { // 通过vuex state获取当前的user是否存在
        var isuserdata = localStorage.getItem('userdata');
        var jsonUserdata = JSON.parse(isuserdata);
        if (jsonUserdata.userId && jsonUserdata.userId == '10853') {
          if (to.path != '/goodsdetail' || to.path != '/goodsList' || to.path != '/login' || to.path != '/register' || to.path != '/retrievePassword') {
            next('/goodsList?page=newFlag');
          } else {
            next();
          }
        } else if (jsonUserdata.userId && jsonUserdata.userId != '10853') {
          next();
        } else {
          next('/goodsList?page=home');
        }
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      next();
    }
  } else {
    next({
      path: '/login',
      query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    })
  }
})
// Vue.use(Element, {
//     i18n: (key, value) => i18n.t(key, value), // 这里会根据选的语言切换Element-ui的语言
// })
// 禁止在控制台打印
// console.log = function(){}
//  alert = function(){}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store, //使用store vuex状态管理
  components: { App },
  template: '<App/>',

  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }

})



// WEBPACK FOOTER //
// ./src/main.js